<template>
	<div>
		<indexHeader ref="indexHeader"></indexHeader>
		<div class="cfzl-wrap">
		    <p class="cfzl-title">处罚资料</p>
		    <el-button class="btn" type="primary" @click="addCfzl()">+ 新增</el-button>
		     <div class="clearfix" style="margin-bottom:80px;">
		     <div class="cftzs-wrap" @click="drawer = true">
		       <div class="cftzs-img">
		          <img src="" alt="">
		       </div>
		       <div class="cftzs-name">处罚通知书</div>
		    </div>
		    <div class="cftzs-wrap">
		       <div class="cftzs-img">
		       </div>
		       <div class="cftzs-name">履约证明</div>
		    </div>
		    <div class="cftzs-wrap">
		       <div class="cftzs-img">
		       </div>
		       <div class="cftzs-name">信用承诺书</div>
		    </div>
		    <div class="whsj-input">
		      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
		        <el-form-item label="处罚文号" prop="name">
		          <el-input v-model="ruleForm.name" placeholder="填写处罚文号"></el-input>
		        </el-form-item>
		         <el-form-item label="处罚时间" prop="cfsj">
		           <el-date-picker placeholder="选择时间" v-model="ruleForm.cfsj" style="width: 100%;"></el-date-picker>
		        </el-form-item>
		      </el-form>
		    </div>
		    </div>
		     <el-drawer
		    title="处罚资料"
		    :visible.sync="drawer">
		    <p class="drawer_p">只能上传jpg/png文件，且不超过2MB！</p>
		    <div class="input_ul clearfix">
		      <div
		        class="input_li load_inLeft"
		      >
		        <img>
		        <div class="mask iconfont"
		             >&#xe745;</div>
		      </div>
		      <div class="uploadBnt">
		        <input type="file" id="drawerFileInput">
		        <div class="bg iconfont" >&#xe740;</div>
		      </div>
		    </div>
		    <el-button type="primary" size="mini" style="margin: 20px 0 0 15px">上一项</el-button>
		    <el-button type="primary" size="mini" style="margin: 20px 0 0 15px">下一项</el-button>
		  </el-drawer>
		</div>
		
		<indexFooter></indexFooter>
	</div>
  
</template>
<script>
	import indexHeader from "@/components/index/index_header";
	import indexFooter from "@/components/index/index_footer";
export default {
  name: "cfzl",
  data() {
    return {
      ruleForm: {
        name: "",
        cfsj: ""
      },
      drawer:false,
      rules: {
        name: [
          { required: true, message: "请输入活动名称", trigger: "blur" },
          { min: 3, max: 5, message: "长度在 3 到 5 个字符", trigger: "blur" }
        ],
        cfsj: [
          {
            type: "date",
            required: true,
            message: "请选择日期",
            trigger: "change"
          }
        ]
      }
    };
  },
  mouted(){

  },
  components: {
    indexHeader,
    indexFooter
  },
  methods:{
    addCfzl(){

    },
    fileChange(e){
        // console.log(e);
        let _self = this;
        if(e.target.files[0]){
          let size = e.target.files[0].size / 1024 / 1024;

          if(size > 2){
            this.$message.error('图片大小不能超过2M！');
            return false;
          }

          let fileName = e.target.files[0].name.replace(/.+\./, "");
          if(['jpg','png','jgeg'].indexOf(fileName.toLowerCase()) === -1){
            this.$message.error('请上传jpg、png格式的图片！');
            return false;
          }

          let reads = new FileReader();
          reads.readAsDataURL(e.target.files[0]);
          reads.onload = function(){
            let temp = {
              objfile : e.target.files[0],
              url : this.result
            };
            _self.form.file[_self.activeType].push(temp);
            _self.form.file[_self.activeType].splice();
            e.target.value = '';
          }

        }

      },
  }
};
</script>
<style scoped lang="less" type="text/less">
.drawer_p{
    padding-left: 15px;
    font-size: 14px;
    margin-bottom: 10px;
    color: #909399;
  }
  .uploadBnt{
    width: 100px;
    height: 120px;
    overflow: hidden;
    float: left;
    margin-bottom: 10px;
    .bg{
      width: 100px;
      height: 120px;
      position: absolute;
      left: 0;
      top: 0;
      background: #d2d2d2;
      font-size: 20px;
      text-align: center;
      line-height: 120px;
      color: #fff;
      cursor: pointer;
      z-index: 1;
    ;
    }
  }
  .input_ul{
    margin-left: 15px;
    .input_li{
      width: 100px;
      height: 120px;
      float: left;
      cursor: pointer;
      margin-right: 15px;
      margin-bottom: 10px;
      img{
        display: block;
        width: 100%;
        height: 100%;
      }
      .mask{
        position: absolute;
        left: 0;
        top: 0;
        background: rgba(0,0,0,0.3);
        text-align: center;
        width: 100px;
        height: 120px;
        line-height: 120px;
        color: #fff;
        cursor: pointer;
        z-index: 1;
      }
      .mask:hover{
        background: rgba(0,0,0,0.5);
        font-size: 18px;
      }
    }

  }
.cfzl-wrap {
  padding: 30px 100px;
  width: 1010px;
  margin: 20px auto;
  background-color: #fff;
  .btn {
    position: absolute;
    top: 30px;
    right: 100px;
    font-size: 16px;
  }
  .cfzl-title {
    font-size: 24px;
    color: #06103b;
    text-align: center;
    margin-bottom: 65px;
  }
  .clearfix {
    clear: both;
  }
  .cftzs-wrap {
    float: left;
    margin-right: 60px;
    .cftzs-img {
      width: 100px;
      height: 100px;
      box-shadow: 0px 0px 15px #d3d5d6;
      margin-bottom: 10px;
      img{
        width: 100%;
        height: 100%;
      }
    }
    .cftzs-name {
      text-align: center;
    }
  }
  .whsj-input {
    width: 520px;
    float: left;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/index/index_cfzl.vue